// Events the tour publishes to open UI panels deterministically.
//
// The tour used to open dialogs by faking DOM clicks
// (`document.querySelector(".step-3").click()`), which was order-dependent and
// brittle. Instead, a step publishes one of these events and the owning
// component reacts by driving its own open state — no DOM reach-in, no timing
// hacks. Subscribe via the shared eventBus (lib/eventbus.ts).
export const TOUR_EVENT = {
  // Reuses the existing "openSettings" listener in components/main/settings.tsx
  // (which already calls setSettingsOpen(true)) — no duplicate subscriber needed.
  openSettings: "openSettings",
  openChat: "tour:open-chat",
} as const;

export type TourEvent = (typeof TOUR_EVENT)[keyof typeof TOUR_EVENT];
